import { type InputHTMLAttributes, type ReactNode, forwardRef } from 'react';

import { classNames } from './classNames';

export type RadioProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  description?: ReactNode;
  label: ReactNode;
};

export const Radio = forwardRef<HTMLInputElement, RadioProps>(
  ({ className, description, label, ...props }, ref) => (
    <label className={classNames('hotam-choice', className)}>
      <input
        ref={ref}
        className='hotam-choice__control'
        type='radio'
        {...props}
      />
      <span className='hotam-choice__content'>
        <span className='hotam-choice__label'>{label}</span>
        {description && <span className='hotam-choice__description'>{description}</span>}
      </span>
    </label>
  ),
);

Radio.displayName = 'Radio';
